import type { RouteLocationNormalized } from 'vue-router'
import { useToast } from 'vue-toastification'
import { useAuthStore } from '~/store/auth'

// Webview z aplikace se autorizuje session cookie na API, přihlášeného
// uživatele v localStorage nemá – na login bychom ho vyhodili zbytečně.
const isAppWebview = (to: RouteLocationNormalized) =>
  to.query.layout === 'none' || String(useCookie('wv').value) === '1'

// Přístup na stránky. Výchozí stav je "jen pro přihlášené", stránka si přes
// definePageMeta říká o výjimku (auth: false / 'guest') nebo o roli (roles).
// Je to jen UX vrstva – skutečnou kontrolu dělá API, tohle brání tomu, aby se
// uživatel proklikal někam, kde stejně nic neuvidí.
export default defineNuxtRouteMiddleware((to) => {
  // Přihlášeného uživatele držíme v localStorage, na serveru o něm nevíme nic
  if (import.meta.server) return

  const auth = useAuthStore()
  if (!auth.user) auth.hydrate()

  const pageAuth = to.meta.auth
  const roles = to.meta.roles

  if (!auth.isLoggedIn) {
    if (pageAuth === false || pageAuth === 'guest') return
    if (isAppWebview(to)) return

    return navigateTo({ path: '/', query: { redirect: to.fullPath } })
  }

  // Přihlášený na přihlašovací obrazovce – rovnou dovnitř
  if (pageAuth === 'guest') {
    return navigateTo(loginRedirectTarget(to.query.redirect))
  }

  if (roles?.length && !roles.includes(auth.user.role)) {
    useToast().error('Na tuto stránku nemáte přístup')
    return navigateTo(useRuntimeConfig().public.homeLink as string)
  }
})
